// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"L0-z","subtitle":"M0-z","wrapper":"N0-z","leftArrow":"O0-z","rightArrow":"P0-z"};